<template>
  <v-container class="pt-0">
    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              :class="{ 'disabled-card': item.limit_reached }"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              :disabled="checkExpire(item.expires_at, item.limit_reached)"
              @click="confirmRedeem(item)"
            >
              <div
                v-if="item.limit_reached"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardLimitReached") }}</div>
              </div>
              <div
                v-else-if="item.status == 'coming soon'"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardComingSoon") }}</div>
              </div>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>

              <v-row
                v-if="!checkExpire(item.expires_at)"
                class="bottomleft mb-0 text-start text-subtitle-2"
              >
                <div class="ma-1">
                  <PointSymbol
                    v-if="
                      Array.isArray(item.point_used) &&
                      item.point_used.length > 0
                    "
                    :type="item.point_used[0].point_type_type"
                    :symbol="item.point_used[0].point_type_symbol"
                    :color="item.point_used[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                </div>
                <p
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  class="pa-0 my-1 pl-0 text-truncate"
                  :style="{ color: site.color }"
                >
                  {{ item.point_used[0].point | commaPoint }}
                  {{ item.point_used[0].point_type_name }}
                </p>
              </v-row>

              <v-row class="bottomleft mb-0 text-start text-subtitle-2" v-else>
                <v-img
                  :src="require('@/assets/images/expired.png')"
                  max-height="20"
                  max-width="20"
                  class="ma-1 d-block"
                ></v-img>
                <p class="pa-0 my-1 pl-0 text-truncate">
                  {{ $t("expireTime") }}
                </p>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <v-dialog v-model="dialogAddFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4">
          {{ $t("confirmAdd") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            rewardData.name
          }}</span
          ><br />
          {{ $t("inYourFav") }} ?
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="addFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogAddFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4" :color="site.color">
          {{ $t("confirmDelete") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            rewardData.name
          }}</span
          ><br />
          {{ $t("fromYourFav") }} ?
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="deleteFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogDeleteFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialogDetail="dialogDetail"
      :item="rewardData"
      :site="site"
      :keyComponent="keyComponent"
      @addFavorite="addFavorite"
      @deleteFavorite="deleteFavorite"
      @redeemRewardFinal="redeemRewardFinal"
      @close="dialogDetail = false"
    />

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeemFinalVisible"
      :site="site"
      :item="rewardData"
      :quantity="quantity"
      @close="closeConfirmDialog()"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import dialogDetailReward from "@/components/reward/dialogDetail.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import PointSymbol from "../point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    dialogDetailReward,
    DialogConfirmRedeemFinal,
    PointSymbol,
  },
  data: () => ({
    dataItems: [],
    dialogDeleteFavorite: false,
    dialogDetail: false,
    dialogAddFavorite: false,
    dialogConfirmRedeemFinalVisible: false,
    rewardData: "",
    next_page_url: "",
    infiniteId: +new Date(),
    keyComponent: 0,
    quantity: null,
  }),
  created() {},
  methods: {
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get("reward/listReward", {
        params: {
          category: "all",
          tag_id: this.$route.params.id,
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          setTimeout(() => {
            this.isAppLoading(false);
          }, 1000);
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.dataItems = this.dataItems.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((err) => {
          console.log("infiniteHandler[err]", err);
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },

    // ========== ========== Favorite ========== ==========
    addFavorite() {
      Axios.post(`reward/addFevoriteItem`, {
        reward_id: this.rewardData.id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.rewardData.is_fevorite = !this.rewardData.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    deleteFavorite() {
      Axios.delete(`reward/deleteFavoriteItem`, {
        data: { reward_id: this.rewardData.id },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.rewardData.is_fevorite = !this.rewardData.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    // ========== ========== Map ========== ==========
    checkExpire(date, limit_reached) {
      if (limit_reached) return limit_reached;
      return moment().isAfter(date, "day");
    },

    // ========== ========== ========== ==========
    confirmRedeem(item) {
      if (item.limit_reached) return;
      this.rewardData = item;
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.rewardData = { ...this.rewardData, ...data };
            this.dialogDetail = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    closeConfirmDialog() {
      this.dialogDetail = true;
      this.dialogConfirmRedeemFinalVisible = false;
    },
    redeemRewardFinal(quantity) {
      this.quantity = quantity;
      this.dialogDetail = false;
      this.dialogConfirmRedeemFinalVisible = true;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.v-btn__content {
  display: flex;
  flex-direction: column;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-header {
  height: 150px;
  font-size: 14px;
}

.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}

.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}

.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}

.empty {
  opacity: 1;
}

.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.disabled-card {
  /* background-color: #00000033; */
}

.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}

.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
}
</style>
